import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_API_KEY

const createMockSupabaseClient = () => {
	const createQuery = () => {
		const query = {
			select: () => query,
			insert: () => Promise.resolve({ data: null, error: null }),
			upsert: () => Promise.resolve({ data: null, error: null }),
			update: () => Promise.resolve({ data: null, error: null }),
			delete: () => Promise.resolve({ data: null, error: null }),

			eq: () => query,
			gte: () => query,
			lte: () => query,
			order: () => query,
			limit: () => query,

			single: () => Promise.resolve({ data: null, error: null }),

			// allow: await supabase.from(...).select()
			then: (resolve) =>
				resolve({ data: [], error: null })
		}

		return query
	}

  console.warn('Supabase env missing — using mock client (test mode)')

	return {
		from: () => createQuery(),

		auth: {
			getSession: async () => ({ data: { session: null }, error: null }),
			onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } }),
			signInWithPassword: async () => ({ data: { user: null }, error: null }),
			signUp: async () => ({ data: { user: null }, error: null }),
			signOut: async () => ({ error: null }),
			resetPasswordForEmail: async () => ({ error: null }),
			updateUser: async () => ({ error: null }),
		},

		channel: (_name, _opts) => {
			const ch = {
				on: () => ch,
				subscribe: (cb) => { if (cb) cb('SUBSCRIBED'); return ch; },
				unsubscribe: () => Promise.resolve(),
				track: () => Promise.resolve(),
				untrack: () => Promise.resolve(),
				presenceState: () => ({}),
			};
			return ch;
		},

		rpc: async () => ({ data: null, error: null })
	}
}

export const supabase =
	!supabaseUrl || !supabaseKey
		? (() => {
		if (import.meta.env.MODE !== 'test') {
			// eslint-disable-next-line no-console
			console.error(
				'[kosteczki] SUPABASE KEYS MISSING — set VITE_SUPABASE_URL and ' +
				'VITE_SUPABASE_PUBLISHABLE_API_KEY in your .env file. ' +
					'All features are disabled (mock client active).'
				);
			}
			return createMockSupabaseClient();
		})()
		: createClient(supabaseUrl, supabaseKey)
